import * as CONST from '../ActionTypes';

const initialState = {
  paymentPageList: [],
};

function paymentPage(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 決済画面一覧取得
    // -----------------
    case CONST.GET_PAYMENT_PAGE_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          paymentPageList: action.payload,
        },
      );
    case CONST.GET_PAYMENT_PAGE_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          paymentPageList: [],
        },
      );
    default:
      return state;
  }
}

export default paymentPage;
